export default __webpack_public_path__ + "static/media/chickTtsIt_It60.3649b5c0.mp3";